import { createFileRoute, redirect } from '@tanstack/react-router'
import { EmailCampaignsPage } from '@/pages/EmailCampaigns/EmailCampaignsPage'
import { useAuthStore } from '@/store/authStore'
import { canAccessRoute } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/email-campaigns')({
  component: EmailCampaignsPage,
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (!canAccessRoute(role, '/email-campaigns')) {
      throw redirect({ to: '/' })
    }
  },
})
